import(/* webpackMode: "eager", webpackExports: ["AffiliatesDosDonts"] */ "/vercel/path0/src/components/affiliatesDosDonts/affiliatesDosDonts.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AffiliatesHero"] */ "/vercel/path0/src/components/affiliatesHero/affiliatesHero.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AffiliatesSteps"] */ "/vercel/path0/src/components/affiliatesSteps/affiliatesSteps.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AffiliatesWhyPartner"] */ "/vercel/path0/src/components/affiliatesWhyPartner/affiliatesWhyPartner.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Faq"] */ "/vercel/path0/src/components/faq/faq.comp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformsBanner"] */ "/vercel/path0/src/components/platformsBanner/platformsBanner.comp.tsx");
